import React from "react";
import { Link } from "react-router-dom";

// Assets
import NotFoundIcon from '../assets/images/svg/404.svg';

const NotFound = () => {
  return (
    <div className=" h-screen bg-primary-blue text-white flex flex-col justify-center items-center px-5">
      <img
        src={NotFoundIcon}
        alt="notFound"
      />
      <h1 className="text-3xl pt-12 pb-8 font-bold">Oh non ! </h1>
      <h2 className="text-2xl font-semibold pb-12">Nous ne trouvons pas la page que vous recherchez !</h2>
      <Link
        className=" bg-white-admin text-blue-admin font-semibold text-xl py-5 w-[318px] text-center rounded-xl"
        to="/"
      >
        Retour au menu
      </Link>
    </div>
  );
};

export default NotFound;
